module.exports = __webpack_public_path__ + "static/media/HK_Transport_2026_Logo.6679c091.png";